import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { PingResult } from '../../../models/app/ping-result';

@Component({
  selector: 'app-ping-test',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ping-test.component.html',
})
export class PingTestComponent {
  result = input.required<PingResult>();
}
